import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Constants } from '../../core/config/Constants';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { ExtraService } from '../../core/services/extra.service';
import * as firebase from 'firebase';
import { ActivatedRoute, Router } from '@angular/router';
import { MultiUtility } from '../../shared/multi-utility';
import { MultiUtilityService } from '../../core/services/multi-utility.service';
import { Category } from '../../core/models/category';
import { Organizer } from '../../core/models/organizer';
import { OrganizersService } from '../../core/services/organizers.service';

@Component({
	selector: 'app-organizer-add',
	templateUrl: './organizer-add.component.html',
	styleUrls: ['./organizer-add.component.css']
})
export class OrganizerAddComponent extends MultiUtility implements OnInit {

	@ViewChild('dropDown', { read: ViewContainerRef }) dropDown: ViewContainerRef;

	buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;
	eventId: string;

	pageTitle: string = 'Create Organizer';
	editTitle: string = 'Edit Organizer';

	organizerId: string;
	organizerCount = 0;
	organizer: Organizer = new Organizer();
	organizerTypeText: string;

	categoryOrderList: Array<any> = [];

	bannerImageFile: File = null;
	iconImageFile: File = null;

	progress: { percentage: number } = { percentage: 0 };

	uploadImgTypeBanner = Constants.IMAGE_UPLOAD_TYPE_BANNER;
	uploadImgTypeIcon = Constants.IMAGE_UPLOAD_TYPE_ICON;

	log(event: boolean) {
		console.log(`Accordion has been ${event ? 'opened' : 'closed'}`);
	}

	constructor(private router: Router,
		newPageService: NewPageService,
		_cfr: ComponentFactoryResolver,
		private organizerService: OrganizersService,
		extraService: ExtraService,
		multiUtilityService: MultiUtilityService,
		private route: ActivatedRoute) {

		super(multiUtilityService, extraService, newPageService, _cfr);
	}

	ngOnInit() {
		super.initComponentThings();
		this.initOrganizerInfo();
	}

	private initThings() {
		this.aboutListUp(this.organizer, this.dropDown);
		this.aboutListDown(this.organizer, this.dropDown);
		this.aboutListRemove(this.organizer);
	}

	private initOrganizerInfo() {
		this.route.queryParams.subscribe(params => {
			this.eventId = params['eventId'];
			this.getOrganizerCategory(params['eventId']);

			if (params['eventId']) {
				if (params['organizerId']) {
					this.organizerId = params['organizerId'];
					this.getOrganizerById(params['eventId'], params['organizerId']);
				} else {
					this.getOrganizerCount(params['eventId']);
				}
			}
			this.extraService.setCurrentEventId(params['eventId']);
		});
	}

	getOrganizerCategory(id) {
		this.categoryOrderList = [];
		this.organizerService.getOrganizerType(id).subscribe(event => {
			if (event) {
				for (let key in event) {
					let organizerOrderType = new Category(); // Should I make it some generic method, It is used by Sponsors also
					organizerOrderType.$key = key;
					organizerOrderType.position = event[key].position;
					organizerOrderType.text = event[key].text;
					this.categoryOrderList[event[key].position] = organizerOrderType;
				}
			}
		});
	}

	getOrganizerById(eventId: string, organizerId: string) {
		this.organizerService.getSingleOrganizer(eventId, organizerId).subscribe(event => {
			if (event) {
				// this.organizer = event;
				// this.organizer = event as Organizer;
				// this.organizer = <Organizer>event;
				// this.organizer = (Organizer)event;
				// this.organizer = new Organizer(event);

				this.organizer = new Organizer();
				this.organizer.name = event.name;
				this.organizer.website = event.website === undefined ? null : event.website;
				this.organizer.type = event.type === undefined ? null : event.type;
				this.organizer.position = event.position;
				this.organizer.bannerCMId = event.bannerCMId === undefined ? null : event.bannerCMId;
				this.organizer.bannerUrl = event.bannerCMId === undefined ? null : event.bannerUrl;
				this.organizer.organization = event.organization === undefined ? null : event.organization;
				this.organizer.designation = event.designation === undefined ? null : event.designation;
				this.organizer.email = event.email === undefined ? null : event.email;
				this.organizer.phoneNo = event.phoneNo === undefined ? null : event.phoneNo;
				this.organizer.isEmailVisible = event.isEmailVisible === undefined ? false : event.isEmailVisible;
				this.organizer.hasDetailsPage = event.hasDetailsPage === undefined ? false : event.hasDetailsPage;
				this.organizer.isPhoneNoVisible = event.isPhoneNoVisible === undefined ? false : event.isPhoneNoVisible;
				this.organizer.aboutList = event.aboutList === undefined ? [] : event.aboutList;

				console.log("huuh  " + this.organizer + "    " + (this.organizer instanceof Organizer));
				if (this.organizer.aboutList) {
					this.organizer.aboutList.forEach(element => {
						this.addComponent(element, this.dropDown, this.eventId);
					});
				}
				this.initThings();

				this.getCategoryItemName(eventId, Constants.CATEGORY_ORGANIZERS, this.organizer.type).subscribe(event => {
					if (event) {
						console.log('getCategoryItemName	:	' + event);
						this.organizerTypeText = event;
					}
				});
			}
		});
	}

	getOrganizerCount(eventId: string) {
		let x = this.organizerService.getOrganizersList(eventId);
		x.snapshotChanges().subscribe(list => {
			this.organizerCount = list.length;
		});
	}

	checkType(key, text) {
		if (key) {
			this.organizer.type = key;
			this.organizerTypeText = text
		}
	}

	addAboutElement() {
		this.showDropDown(this.dropDown, this.organizer, this.eventId);
	}


	uploadImage(event, source) {

		switch (source) {
			case Constants.IMAGE_UPLOAD_TYPE_BANNER:
				console.log('Source Logo :: ', source);
				this.bannerImageFile = event.files[0];
				this.uploadImageToStorage(this.bannerImageFile, firebase, this.organizer, this.eventId, Constants.CONTENT_M_TYPE_ORGANIZERS, Constants.IMAGE_UPLOAD_TYPE_BANNER);
				break;

			case Constants.IMAGE_UPLOAD_TYPE_ICON:
				console.log('Source Icon :: ', source);
				this.iconImageFile = event.files[0];
				this.uploadImageToStorage(this.iconImageFile, firebase, this.organizer, this.eventId, Constants.CONTENT_M_TYPE_ORGANIZERS, Constants.IMAGE_UPLOAD_TYPE_ICON);
				break;
		}
	}

	// deleteLogoImage() {
	//   this.logoImageFile = null;
	// }

	// deleteIconImage() {
	//   this.iconImageFile = null;
	// }

	submit() {
		this.confirmMessage = null;
		this.isError = false;
		this.errorMessage = [];

		if (this.validate(this.organizer)) {
			if (!this.organizerId) {
				this.disableButton = false;
				this.organizer.position = this.organizerCount;
				let organizerKey = this.organizerService.addOrganizerDetails(this.organizer, this.eventId);
				if (organizerKey) {
					this.confirmMessage = 'Added Successfully';
				}

			} else {
				this.disableButton = false;

				this.organizerService.updateOrganizerDetails(this.organizer, this.eventId, this.organizerId).then(res => {
					this.confirmMessage = 'Update Successfully';
				}).catch(error => {
					this.disableButton = true;
					this.errorMessage = error.message;
				});
			}
			setTimeout(function () {
				this.confirmMessage = null;
				this.disableButton = true;
				this.router.navigate([Constants.ORGANIZER_FORM, this.eventId]);
			}.bind(this), 2000);

		} else {
			this.isError = true;
		}
	}

}



// WEBPACK FOOTER //
// /app/src/app/event/organizer-add/organizer-add.component.ts